// extracted by mini-css-extract-plugin
export var description = "LabIntro-module--description--b2jj5";
export var hidden = "LabIntro-module--hidden--BO3Si";